import { Result } from 'antd';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { ResultStatusType } from 'antd/es/result';
import { useNavigate } from 'react-router';

interface Props {
  status?: ResultStatusType;
  title?: string;
  extra?: React.ReactNode;
}

export const ResultPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  return (
    <Result
      status={props.status || 'warning'}
      title={props.title || 'There are some problems with your operation.'}
      extra={
        props.extra || (
          <ButtonComponent
            appereance='primary'
            label='Go back to Dashboard'
            onClick={() => navigate('/home')}
            size='middle'
          />
        )
      }
    />
  );
};
